module.exports = __webpack_public_path__ + "img/353535_CFCFCF_828282_A4A4A4-256px.e4640047.png";